const MoonRing = () => {
    return (
        <mesh>
            <ringGeometry args={[1, 1.16, 128]} />
            <meshBasicMaterial color={'hsla(0, 100%, 72%, 1.00)'} />
        </mesh>
    );
};

export default MoonRing;
